import { configureStore } from "@reduxjs/toolkit";
import { warehouseApi } from "services/api/warehouseApi";
import { statusSlice } from "store/Slices/Status/statusSlice";
import { gridLayoutSlice } from "./Slices/gridLayoutSlice";
import { warehousePlanSlice } from "./Slices/warehousePlanSlice";
/* eslint-disable */
import { useSelector } from "react-redux";
import { appStateSlice } from "./Slices/appStateSlice";
import { connectionApi } from "services/api/connectionApi";
import { locationSlice } from "./Slices/locationSlice";
import { elementDetailsSlice } from "./Slices/elementDetailsSlice";
import { gridEventSlice } from "./Slices/gridEventSlice";
import { logoutUserOnUnauthorizedError } from "./Middleware/rtkQueryErrorManager";

export const store = configureStore({
  reducer: {
    [connectionApi.reducerPath]: connectionApi.reducer,
    [warehouseApi.reducerPath]: warehouseApi.reducer,
    [appStateSlice.name]: appStateSlice.reducer,
    [gridLayoutSlice.name]: gridLayoutSlice.reducer,
    [statusSlice.name]: statusSlice.reducer,
    [warehousePlanSlice.name]: warehousePlanSlice.reducer,
    [locationSlice.name]: locationSlice.reducer,
    [elementDetailsSlice.name]: elementDetailsSlice.reducer,
    [gridEventSlice.name]: gridEventSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(connectionApi.middleware)
      .concat(warehouseApi.middleware)
      .concat(logoutUserOnUnauthorizedError),
});

export type AppDispatch = typeof store.dispatch;
export const useAppSelector = useSelector.withTypes<RootState>();
export type RootState = ReturnType<typeof store.getState>;
